// extracted by mini-css-extract-plugin
module.exports = {"ContentBlock":"ContentBlock_ContentBlock__1c_Qw","ContentBlock__label":"ContentBlock_ContentBlock__label__jr8fN"};